/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PaginatedGuestbookEntry {
  posts: {
    id: number;
    content: string;
  }[];
  pages: number;
}

export interface RawContent {
  content: string;
}

export interface GamesOverview {
  text: string;
  games: GameProps[];
}

export interface GameProps {
  postId: number;
  id: string;
  name: string;
  /** @format url */
  iconUrl: string;
}

export interface GameDetails {
  id: string;
  name: string;
  /** @format url */
  iconUrl: string;
  text: string;
  gallery?: string[];
  team?: Person[];
  sponsors?: string[];
  voices?: Person[];
  teamText?: string;
  sponsorsText?: string;
  voicesText?: string;
}

export interface Person {
  id: number;
  name: string;
  /** @format url */
  picture: string;
  roles: Role[];
}

export interface Role {
  gamePostId: number;
  gameId: string;
  gameName: string;
  roleName: string;
}

export interface ContactForm {
  name?: string;
  /** @format email */
  email: string;
  subject: string;
  message: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title AbenteuerpaketeApi
 * @version 1.0.0
 *
 * Abenteuerpakete API
 */
export class AbenteuerpaketeApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  ap = {
    /**
     * @description Get the text that is displayed on the "Guestbook" page
     *
     * @tags abenteuerpakete
     * @name GetGuestbookText
     * @request GET:/ap/v1/guestbook_text
     */
    getGuestbookText: (params: RequestParams = {}) =>
      this.request<RawContent, void>({
        path: `/ap/v1/guestbook_text`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get at most 5 guestbook entries of a provided page
     *
     * @tags abenteuerpakete
     * @name GetEntries
     * @request GET:/ap/v1/guestbook-entries/{page}
     */
    getEntries: (page: number, params: RequestParams = {}) =>
      this.request<PaginatedGuestbookEntry, void>({
        path: `/ap/v1/guestbook-entries/${page}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Create a new guestboook entry
     *
     * @tags abenteuerpakete
     * @name CreateEntry
     * @request POST:/ap/v1/guestbook-create
     */
    createEntry: (
      post: {
        authorId: string;
        content: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/ap/v1/guestbook-create`,
        method: "POST",
        body: post,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the privacy policy
     *
     * @tags abenteuerpakete
     * @name GetPrivacyPolicy
     * @request GET:/ap/v1/privacy_policy
     */
    getPrivacyPolicy: (params: RequestParams = {}) =>
      this.request<RawContent, void>({
        path: `/ap/v1/privacy_policy`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get the aput text
     *
     * @tags abenteuerpakete
     * @name GetAbout
     * @request GET:/ap/v1/about
     */
    getAbout: (params: RequestParams = {}) =>
      this.request<RawContent, void>({
        path: `/ap/v1/about`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get the imprint
     *
     * @tags abenteuerpakete
     * @name GetImprint
     * @request GET:/ap/v1/imprint
     */
    getImprint: (params: RequestParams = {}) =>
      this.request<RawContent, void>({
        path: `/ap/v1/imprint`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get the general terms and conditions
     *
     * @tags abenteuerpakete
     * @name GetGeneralTermsAndConditions
     * @request GET:/ap/v1/general_terms_and_conditions
     */
    getGeneralTermsAndConditions: (params: RequestParams = {}) =>
      this.request<RawContent, void>({
        path: `/ap/v1/general_terms_and_conditions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get a list of games and the text on the page
     *
     * @tags abenteuerpakete
     * @name GetGames
     * @request GET:/ap/v1/games
     */
    getGames: (params: RequestParams = {}) =>
      this.request<GamesOverview, void>({
        path: `/ap/v1/games`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get details of a game
     *
     * @tags abenteuerpakete
     * @name GetGame
     * @request GET:/ap/v1/games/{gameId}
     */
    getGame: (gameId: string, params: RequestParams = {}) =>
      this.request<GameDetails, void>({
        path: `/ap/v1/games/${gameId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Get team members by ids
     *
     * @tags abenteuerpakete
     * @name GetTeamMembers
     * @request GET:/ap/v1/team_members
     */
    getTeamMembers: (
      query?: {
        memberId?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Person[], void>({
        path: `/ap/v1/team_members`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get voice actors by ids
     *
     * @tags abenteuerpakete
     * @name GetVoiceActors
     * @request GET:/ap/v1/voice_actors
     */
    getVoiceActors: (
      query?: {
        actorId?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Person[], void>({
        path: `/ap/v1/voice_actors`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Send a contact form
     *
     * @tags abenteuerpakete
     * @name SendContactForm
     * @request POST:/ap/v1/contact
     */
    sendContactForm: (form: ContactForm, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/ap/v1/contact`,
        method: "POST",
        body: form,
        type: ContentType.Json,
        ...params,
      }),
  };
}
